type MessageProps = {
  message: string
}

// avatarが左にあるメッセージ（他人）
export function MessageLeft({ message }: MessageProps) {
  return (
    <div className="flex">
      <div className="relative mb-2.5 ml-5 w-fit max-w-[75%] rounded-lg border border-[#90caf9] bg-[#e1f5fe] p-2.5 text-left text-[0.9em] font-normal">
        <p className="m-0 p-0">{message}</p>
      </div>
    </div>
  )
}

// avatarが右にあるメッセージ（自分）
export function MessageRight({ message }: MessageProps) {
  return (
    <div className="flex justify-end">
      <div className="relative mb-2.5 mr-5 w-fit max-w-[75%] rounded-lg border border-[#90caf9] bg-[#f8e896] p-2.5 text-left text-[0.9em] font-normal">
        <p className="m-0 p-0">{message}</p>
      </div>
    </div>
  )
}
